export function trimString(value) {
  try {
    return value.trim() || null;
  }
  catch(e) {
    return value || null;
  }
}
